import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { PetEntity } from 'src/game/logic/EntityManager';
import { PetSpeciesID } from 'src/replicant/pet';
import { ImageView } from '@play-co/timestep-core/ui';
import { petAnimationNames } from 'src/replicant/pet/PetAssets';
import { friendRevivalCost } from 'src/replicant/visit/visit.ruleset';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import { RevivalConfirmPopupInitArgs } from './PopupRevivalConfirm';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (result: boolean) => void;

export default class PopupRevivalConfirmSimple extends PopupBasic {
  private close: CloseHandler;
  private species?: PetSpeciesID;

  constructor(opts: { superview: View; close: CloseHandler }) {
    const { width } = uiConfig.popups.buruburu;

    super({
      superview: opts.superview,
      close: () => opts.close(false),
      zIndex: 10000,
      width,
      height: 550,
      tracking: {
        feature: Feature.VISIT._,
        $subFeature: Feature.VISIT.REVIVE,
      },
    });

    this.close = opts.close;
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      'assets/ui/visit/revive/revival_potion.png',
      'assets/ui/shared/icons/gem.png',
    ]);
  }

  public init({ species, free, secondTime }: RevivalConfirmPopupInitArgs) {
    super.init({});
    this.species = species;

    this.title.setText(() =>
      i18n(`friendsVisit.revive.buy${secondTime ? 'Sure' : ''}.title`),
    );
    this.message.updateOpts({
      localeText: () =>
        i18n(`friendsVisit.revive.buy${secondTime ? 'Sure' : ''}.message`),
      width: 471,
      height: 96,
      align: 'center',
      verticalAlign: 'center',
      size: 27,
      wordWrap: true,
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 130,
    });

    const pet = new PetEntity('revivalPet', species);
    pet.updateOpts({
      superview: this.box,
      x: 20 + this.box.style.width / 4,
      y: 300,
      scale: 0.7,
      centerOnOrigin: true,
    });
    const petAnimations = petAnimationNames[species];
    pet.setAnimation(petAnimations.dead.idle);

    new ImageView({
      superview: this.box,
      image: 'assets/ui/visit/revive/revival_potion.png',
      centerOnOrigin: true,
      width: 185,
      height: 185,
      x: -20 + (3 * this.box.style.width) / 4,
      y: 300,
    });

    const button = new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      labelOffsetY: -1,
      labelOffsetX: 20,
      fontSize: 40,
      font: bitmapFonts('Body'),
      x: this.box.style.width / 2,
      y: 465,
      width: 250,
      height: 110,
      centerOnOrigin: true,
      localeText: () => `${friendRevivalCost}`,
      onClick: async () => {
        sounds.sfx.play('ok');
        return this.close(true);
      },
      tracking: {
        feature: Feature.VISIT._,
        $subFeature: Feature.VISIT.REVIVE_CONFIRM,
      },
    });

    const gem = new ImageView({
      superview: button,
      image: 'assets/ui/shared/icons/gem.png',
      centerOnOrigin: true,
      width: 50,
      height: 47,
      x: button.style.width / 2 - 50,
      y: button.style.height / 2,
      centerAnchor: true,
    });

    if (free) {
      new LangBitmapFontTextView({
        superview: button,
        x: button.style.width / 2 - 5,
        y: 28,
        width: button.style.width,
        height: button.style.height,
        align: 'center',
        verticalAlign: 'center',
        size: 48,
        localeText: () => i18n('match2.bundleSale.free').toUpperCase(),
        font: 'Body',
        color: '#FFF61F',
        centerOnOrigin: true,
      });
      gem.updateOpts({ scale: 0.8, y: 76 });
      button.label.updateOpts({ scale: 0.9, y: 33 });

      new View({
        superview: button,
        x: button.style.width / 2,
        y: 76,
        width: button.style.width * 0.6,
        height: 4,
        centerOnOrigin: true,
        backgroundColor: '#ffffff',
      });

      new LangBitmapFontTextView({
        superview: this.box,
        x: this.box.style.width / 2,
        y: this.box.style.height + 40,
        width: 400,
        height: 35,
        align: 'center',
        verticalAlign: 'center',
        size: 30,
        localeText: () => i18n('friendsVisit.revive.buy.free'),
        font: 'Body',
        color: '#ffffff',
        centerOnOrigin: true,
      });
    }
  }
}
